export const SET_RESPONSES = 'accessibility/SET_RESPONSES'
export const CLEAR_RESPONSES = 'accessibility/CLEAR_RESPONSES'
